import React, { useState, useEffect } from "react";
import { Marker } from "@react-google-maps/api";

const LocationMarker = ({ lat, lng, onClick, icon }) => {
  const [newImage, setNewImage] = useState("");

  // console.log(lat)

  const newIcon = icon.toLowerCase().split(" ").join("");
  const image = {
    wildfires: "https://img.icons8.com/color/25/000000/fire-element--v1.png",
    volcanoes: "https://img.icons8.com/color/25/000000/volcano.png",
    seaandlakeice: "https://img.icons8.com/color/25/000000/iceberg.png",
    severestorms: "https://img.icons8.com/color/25/000000/storm--v1.png",
    drought: "https://img.icons8.com/color/25/000000/drought.png",
    dustandhaze: "https://img.icons8.com/color/25/000000/dust.png",
    earthquakes: "https://img.icons8.com/color/25/000000/earthquakes.png",
    floods: "https://img.icons8.com/color/25/000000/floods.png",
    landslides: "https://img.icons8.com/color/25/000000/landslide.png",
    manmade: "https://img.icons8.com/color/25/000000/complaint.png",
    snow: "https://img.icons8.com/color/25/000000/winter--v1.png",
    temperatureextremes:
      "https://img.icons8.com/color/25/000000/high-temperature-hazard.png",
    watercolor: "https://img.icons8.com/color/25/000000/wave-lines.png",
  };

  useEffect(() => {
    for (const key in image) {
      if (newIcon === key) {
        setNewImage(image[key]);
      }
    }
  }, []);

  return (
    <div className="location-marker" onClick={onClick}>
      <Marker
        position={{ lat, lng }}
        // icon={icon}
        icon={newImage}
        className="location-marker"
        onClick={onClick}
      ></Marker>
    </div>
  );
};

export default LocationMarker;
